import { render, staticRenderFns } from "./AdditionalSourcesMainSection.vue?vue&type=template&id=1a552a2c"
import script from "./AdditionalSourcesMainSection.vue?vue&type=script&lang=js"
export * from "./AdditionalSourcesMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports